"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const search_icon_svg_1 = __importDefault(require("@@/assets/svgs/search_icon.svg"));
const search_icon_heart_svg_1 = __importDefault(require("@@/assets/svgs/search_icon_heart.svg"));
const x_circle_gray_svg_1 = __importDefault(require("@@/assets/svgs/x_circle_gray.svg"));
function default_1({ keyword, setKeyword, onSearchEnter, onSearchCancel, placeholder, heartIcon, }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            alignItems: 'center',
            columnGap: '10px',
            width: '100%',
            height: '32px',
            padding: '0 8px',
            borderRadius: '16px',
            backgroundColor: '#F8F8F8',
            svg: {
                flexShrink: 0,
            },
        } }, { children: [heartIcon ? ((0, jsx_runtime_1.jsx)(search_icon_heart_svg_1.default, { css: { cursor: 'pointer' }, onClick: onSearchEnter })) : ((0, jsx_runtime_1.jsx)(search_icon_svg_1.default, { css: { width: '16px', height: '16px' } })), (0, jsx_runtime_1.jsx)("input", { value: keyword, css: {
                    width: '100%',
                    border: 0,
                    backgroundColor: 'inherit',
                    fontSize: '15px',
                }, placeholder: placeholder, onChange: e => setKeyword(e.target.value), onKeyDown: e => {
                    e.key === 'Enter' && onSearchEnter();
                    e.key === 'Escape' && onSearchCancel();
                } }), Boolean(keyword) && ((0, jsx_runtime_1.jsx)(x_circle_gray_svg_1.default, { css: { width: '16px', height: '16px', cursor: 'pointer' }, onClick: e => {
                    e.currentTarget.previousElementSibling.focus();
                    onSearchCancel();
                } }))] })));
}
exports.default = default_1;
